import React, { useState, useEffect, useMemo } from 'react'
export default function useTimer(duration: number, onFinished: Function) {
    const [time, setTime] = useState<number>(duration);
    useEffect(() => {
        const interval = setInterval(() => {
            setTime((time: number) => {
                if (time > 0) return time - 1;
                else {
                    return time;
                }
            });
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (time <= 0) {
            onFinished();
        }
    }, [time]);

    const timeFormat = useMemo(() => {
        const completerdSeconds = parseInt(time / 60 + "");
        const fractions = parseInt((time % 60) + "");
        return ` ${String(completerdSeconds).padStart(2, "0")}:${String(
            fractions
        ).padStart(2, "0")}`;
    }, [time]);
    return timeFormat
}